import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import GameStatsText from '~/statistics-v2/components/gameStatsText'
import { WindSurferProductStatAPI } from '~/statistics/types/wind-surfer.types'

export default function StatsWindsurfer({ stats }: { stats?: WindSurferProductStatAPI }): React.ReactElement {
  const { t } = useTranslation('statisticsV2')
  // The best run's accuracy, computed server-side. This card shows personal bests; the panel's
  // headline accuracy uses the latest run instead, so the two are meant to differ.
  const accuracy = Math.round(stats?.summary.bestAccuracy ?? 0)

  return (
    <div className="flex flex-1 flex-col gap-2 p-4 bg-purple-midnight rounded border border-purple min-w-50">
      <div className="flex gap-2 items-center h-12">
        <ResponsiveImage height={40} srcKey="gamification/games/wind-surfer.png" width={40} />
        <h3 className="text-white text-sm font-bold">{t(`games.windSurfer`)}</h3>
      </div>
      <span className="border-b border-purple" />
      <div className="flex flex-col gap-2 py-2">
        <GameStatsText text={t('games.highscore')} value={stats?.summary.bestScore || 0} />
        <GameStatsText text={t('games.bestStreak')} value={stats?.summary.bestStreak || 0} />
        <GameStatsText text={t('games.accuracy')} value={`${accuracy || 0}%`} />
      </div>
    </div>
  )
}
